import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultas',
  templateUrl: './consultas.component.html',
  styleUrls: ['./consultas.component.css']
})
export class ConsultasComponent implements OnInit {
  code1:string = `this._placeService.getPlace(this.uid).take(1).subscribe(place => { <br>
    &nbsp; this.place = place; <br>
  }, err => { <br>
    &nbsp;  this.navCtrl.push(ErrorPage, {message: "datosLugar", error: err, page: this.navCtrl.getActive().name}); <br>
  }); ;`;

  code2:string = `this.subscriptionGetPlace = this._placeService.getPlace(this.uid).subscribe(place => { <br>
    &nbsp; this.place = place; <br>
  }, err => { <br>
    &nbsp;  this.navCtrl.push(ErrorPage, {message: "datosLugar", error: err, page: this.navCtrl.getActive().name}); <br>
  }); ;`;

  code3:string = "ionViewDidLeave(){}";

  code4:string = `if(this.subscriptionGetPlace != null){ <br>
    &nbsp;&nbsp; this.subscriptionGetPlace.unsubscribe(); <br>
  }`;

  code5:string = `getPlace(uidPlace:any){ <br>
    &nbsp;&nbsp; return this.db.collection('places').doc(uidPlace).valueChanges(); <br>
  }`;

  code6:string = `return this.db.collection('places').snapshotChanges().map(actions => { <br>
    &nbsp;&nbsp; return actions.map(action => { <br>
      &nbsp;&nbsp; const data = action.payload.doc.data(); <br>
      &nbsp;&nbsp;  data.uid = action.payload.doc.id; <br>
      &nbsp;&nbsp; return data; <br>
    &nbsp;&nbsp; });  <br>        
  }); `;

  code7:string = `return this.db.collection('places', ref => ref.where('strPais',"==", pais).orderBy("fechaCreacion", "asc").limit(20)).snapshotChanges().map(actions => { <br>
    &nbsp;&nbsp; return actions.map(action => { <br>
      &nbsp;&nbsp; const data = action.payload.doc.data(); <br>
      &nbsp;&nbsp;  data.uid = action.payload.doc.id; <br>
      &nbsp;&nbsp; return data; <br>
    &nbsp;&nbsp; });  <br>        
  }); `;

  code8:string = `return this.db.collection('places', ref => ref.where('strPais',"==", pais).orderBy("fechaCreacion", "asc").startAfter(fechaCreacion).limit(20)).snapshotChanges().map(actions => { <br>
    &nbsp;&nbsp; return actions.map(action => { <br>
      &nbsp;&nbsp; const data = action.payload.doc.data(); <br>
      &nbsp;&nbsp;  data.uid = action.payload.doc.id; <br>
      &nbsp;&nbsp; return data; <br>
    &nbsp;&nbsp; });  <br>        
  }); `;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Consejos/consultas/consultas.component.ts